export default {
  about: "O kurzu",
  content: "Obsah kurzu",
  steps: "Počet kroků",
  credits: "Kreditů",
  free: "Zdarma",
  purchased: "Zakoupeno",
  chapter: "Kapitola",
  lesson: "Krok",
  lessons: "kroků",
  buttons: {
    buyAndPlay: "Koupit a začít",
    continue: "Pokračovat",
    begin: "Začít kurz",
    repeat: "Opakovat | Opakovat za",
    backToJourney: "Zpět do kurzu",
  },
  repeatModal: {
    title: "Opakovat kurz",
    description: "Chcete začít kurz od začátku?",
    cost: "Cena",
    cancel: "Zrušit",
    confirm: "Potvrdit",
  },
};
